/**
 * Handle chart kind type
 */
export enum ChartSerieKind {
  LINE = 0,
  BAR = 1,
  AREA = 2,
  PIE = 3,
}

/**
 * Handle chart series point style
 */
export enum ChartSeriePointStyle {
  SQUARE = 0,
  CIRCLE,
  TRIANGLE_UP,
  TRIANGLE_DOWN,
  PLUS,
  X,
  STAR,
  DIAMOND,
  DOT,
  TRIANGLE_LEFT = 10,
  TRIANGLE_RIGHT,
  HEXAGON,
  DONUT = 14,
  ARROW_RIGHT,
}

/**
 * Handle chart time UM period
 */
export enum ChartTimeUM {
  MINUTE = 0,
  HOUR = 1,
  DAY = 2,
  WEEK = 3,
  MONTH = 4,
  YEAR = 5,
  SECOND = 6,
  PERIOD = 99,
}
